module.exports = __webpack_public_path__ + "static/fig-05-d533ac0c63c8a412faea04d36a60be6b.png";